export const log_name = "exly_webapp_fed";
